import docciergeLogo from '../../assets/images/logos/doccierge.svg'
import inIcon from '../../assets/images/icons/footer-in.svg'
import fbIcon from '../../assets/images/icons/footer-fb.svg'
import twitIcon from '../../assets/images/icons/footer-twitter.svg'
import scrollToAnchor from '../../utils/scrollToAnchor'

import './_Footer.scss'
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className='Footer section-padding'>
      <div className='container'>
        <div className='top-line'>
          <div className='logo-box'>
            <button onClick={() => scrollToAnchor('')}>
              <img src={docciergeLogo} alt='Doccierge' className='logo' />
            </button>
          </div>
          <ul className='nav-links'>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('services')} className='link'>Services</button>
              </li>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('features')} className='link'>Features</button>
              </li>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('doctors')} className='link'>Doctors</button>
              </li>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('review')} className='link'>Review</button>
              </li>
            <li className='nav-link'>
              <button onClick={() => scrollToAnchor('location')} className='link'>Location</button>
              </li>
          </ul>
          {false && <ul className='social-links'>
            <li className='social-link'>
              <a href='https://google.com' rel='noreferrer' target='_blank' className='center'>
                <img src={inIcon} alt='LinkedIn' className='icon' />
              </a>
            </li>
            <li className='social-link'>
              <a href='https://google.com' rel='noreferrer' target='_blank' className='center'>
                <img src={fbIcon} alt='Facebook' className='icon' />
              </a>
            </li>
            <li className='social-link'>
              <a href='https://google.com' rel='noreferrer' target='_blank' className='center'>
                <img src={twitIcon} alt='Twitter' className='icon' />
              </a>
            </li>
          </ul>}
        </div>
        <div className='bottom-line'>
          <Link to="/" className='link'>Home</Link>
          <Link to="/policy" className='link'>Privacy Policy</Link>
          <Link to="/terms" className='link'>Terms and Condition</Link>
          <p className='copyright'>© Doccierge, all rights reserved 2023</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
